import { render } from "./ChallengesSection.vue?vue&type=template&id=684bacdc&scoped=true"
import script from "./ChallengesSection.vue?vue&type=script&lang=js"
export * from "./ChallengesSection.vue?vue&type=script&lang=js"

import "./ChallengesSection.vue?vue&type=style&index=0&id=684bacdc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684bacdc"]])

export default __exports__